var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notNull"},[_c('div',{staticClass:"fzfbox"},[_c('strong',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.type=='coupons'? _vm.$t('base.noCoupons'):_vm.text))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ed232e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notnull.vue
// module id = null
// module chunks = 